import moment from "moment";
const isFutureDate = (selectedDate, setFormState, name) => {
  let todayDate = moment().format("YYYY-MM-DD");
  name = name.split('"').join(" ");
  if (selectedDate <= todayDate) {
    setFormState((formState) => ({
      ...formState,
      [name]: selectedDate,
    }));
  } else {
    setFormState((formState) => ({
      ...formState,
      [name]: todayDate,
    }));
  }
};

export default isFutureDate;
